var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgStudentCap(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1619_1132)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M6.99999 8.82266L6.60741 8.68208L2.33332 7.15433V11.0837C3.57932 12.1698 5.20916 12.8337 6.99999 12.8337C8.79082 12.8337 10.4207 12.1698 11.6667 11.0837V7.15433L7.39316 8.68208L6.99999 8.82266ZM13.9942 4.66699C14.0163 4.40041 13.888 4.12216 13.5963 3.99674L6.99999 1.16699L0.404824 3.99674C-0.152843 4.23591 -0.128343 5.03508 0.443323 5.23924L6.99999 7.58366L12.8333 5.49824V9.33366C12.8333 9.65566 13.0947 9.91699 13.4167 9.91699C13.7387 9.91699 14 9.65566 14 9.33366V4.66699H13.9942Z",
    fill: "#507CD4"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1619_1132"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 14,
    height: 14,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStudentCap);
export default __webpack_public_path__ + "static/media/student-cap.4cadbc79a64fc4d844d93b9ae595179f.svg";
export { ForwardRef as ReactComponent };